export function extractPrimaryAnswer(answer: string): string {
  const firstLine = answer.split('\n')[0].trim();
  if (firstLine.toLowerCase().startsWith('grundform:')) {
    return firstLine.slice(firstLine.indexOf(':') + 1).trim();
  }
  return firstLine;
}
